"use client";

import React from "react";
import { ShieldCheck } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const complianceStandards = [{
  id: "obagi",
  name: "Obagi Medical",
  description: "World-renowned pharmaceutical-grade skincare designed to transform your skin at a cellular level.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/obagi_logo.png"
}, {
  id: "skinceuticals",
  name: "SkinCeuticals",
  description: "Advanced professional skincare backed by science and clinical research for optimal skin health.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/skinceuticals_logo.png"
}, {
  id: "hydrafacial",
  name: "HydraFacial",
  description: "The ultimate medical-grade resurfacing treatment for immediate clarity and long-lasting glow.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/hydrafacial_logo.png"
}, {
  id: "alumiermd",
  name: "AlumierMD",
  description: "Clean, medical-grade skincare that delivers therapeutic results for all unique skin conditions.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/alumiermd_logo.png"
}, {
  id: "lycon",
  name: "Lycon Precision",
  description: "The gold standard in hair removal, providing a virtually painless experience for sensitive skin.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/lycon_logo.png"
}];
export default function StandardizationCompliance() {
  return;
}